module.exports = {"hello":"Hello!","language":"Language"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en.json
// module id = 668
// module chunks = 1